function baseGt(value,other){return value>other}module.exports=baseGt;